import {RegisterType} from '../component-registry';
import {GuidedUiPnaSection, GuidedUiQuickLinkSection} from '../../models/Guided.schema';
import {GuidedQuickLinkDetails} from '../../models/quick-link';
import { GuidedV2ResultListFactory } from '../result-list-section/ui';
import type { GuidedV2FactoryState } from '../../models/ui';


export class GuidedV2GuidedUiPnaSectionFactory {

  protected delegated = new GuidedV2ResultListFactory();

  @RegisterType(GuidedUiPnaSection.type)
  render<T extends GuidedQuickLinkDetails>(
    inputData: GuidedUiQuickLinkSection,
    state: GuidedV2FactoryState<T>) {

      return this.delegated.render(inputData,state);

  };
}
